export const LAUNCH_DARKLY_KEY = process.env.LAUNCH_DARKLY_KEY ?? '';
